import { createFileRoute } from "@tanstack/react-router";
import { cn } from "cn";
import * as z from "zod";
import ResponsiveWrapper from "@/components/ui/layout/box/responsive-wrapper";
import PublicLayout from "@/components/ui/layout/public-layout";
import { AuthRedirectProvider } from "@/features/auth/_providers/auth-redirect-provider";
import { ResetPassword } from "@/features/auth/reset-password";

export const Route = createFileRoute("/(auth)/reset-password")({
  validateSearch: z.object({
    redirect_url: z.string().optional(),
  }),
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  return (
    <AuthRedirectProvider>
      <PublicLayout>
        <ResponsiveWrapper
          className={cn(
            /* sorted */
            "grow",
            "py-12",
            "sm:mx-auto sm:w-full sm:max-w-[25.5rem]",
          )}
        >
          <ResetPassword />
        </ResponsiveWrapper>
      </PublicLayout>
    </AuthRedirectProvider>
  );
}
